import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Observable } from 'rxjs';

import { CMSFacade } from 'ish-core/facades/cms.facade';
import { ContentPageTreeView } from 'ish-core/models/content-page-tree-view/content-page-tree-view.model';
import { ContentPageletEntryPointView } from 'ish-core/models/content-view/content-view.model';
import { ContentPageRoutePipe } from 'ish-core/routing/content-page/content-page-route.pipe';
import { SkipContentLinkComponent } from 'ish-shared/components/common/skip-content-link/skip-content-link.component';

/**
 * The Content Page Navigation Component to get content page hierarchy navigation.
 */
@Component({
  selector: 'ish-content-navigation',
  templateUrl: './content-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, ContentPageRoutePipe, SkipContentLinkComponent],
})
export class ContentNavigationComponent implements OnInit {
  private cmsFacade = inject(CMSFacade);

  /**
   * Content Page Tree to be rendered
   */
  readonly contentPageTree = input.required<ContentPageTreeView>();
  /**
   * Max Depth of page tree
   */
  readonly depth = input.required<number>();

  currentContentPage$: Observable<ContentPageletEntryPointView>;

  ngOnInit() {
    this.currentContentPage$ = this.cmsFacade.contentPage$;
  }
}
